import { render, staticRenderFns } from "./ControlsDropdownItem.vue?vue&type=template&id=5228f2f4&scoped=true&"
import script from "./ControlsDropdownItem.vue?vue&type=script&lang=js&"
export * from "./ControlsDropdownItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5228f2f4",
  null
  
)

export default component.exports